/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SkillsControllerUpdateMutationResponse, SkillsControllerUpdatePathParams, SkillsControllerUpdate400, SkillsControllerUpdate401, SkillsControllerUpdate403, SkillsControllerUpdate404 } from "../../models/skillsController/SkillsControllerUpdate";

function getSkillsControllerUpdateUrl(id: SkillsControllerUpdatePathParams["id"]) {
  const res = { method: 'PUT', url: `/api/v1/skills/${id}` as const }  
  return res
}

/**
 * @summary Replace a skill with validated files
 * {@link /api/v1/skills/:id}
 */
export async function skillsControllerUpdate(id: SkillsControllerUpdatePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SkillsControllerUpdateMutationResponse, ResponseErrorConfig<SkillsControllerUpdate400 | SkillsControllerUpdate401 | SkillsControllerUpdate403 | SkillsControllerUpdate404>, unknown>({ method : "PUT", url : getSkillsControllerUpdateUrl(id).url.toString(), ... requestConfig })  
  return res.data
}